import React from 'react';
import '../../../stylesheets/Follower.css';
import SearchItem from '../../../SearchPage/SearchItem/SearchItem';
// import SearchItem from './SearchItem/SearchItem'
const Followers = ({users}) => {
  
  return (
    <div className="Followers">
      {users?.length > 0 ? (
        users?.map((follower, index) => {
          return (
            <div className="mt-3" key={index}>
            
               <SearchItem user={follower} /> 
            </div>
          );
        })
      ) : (
        <p className="mt-3 font-weight-bold light-color">
          No followers yet
        </p>
      )}
    </div>
  );
};

export default Followers;
